import * as React from "react";
import ProfileQuery from "../../queries/ProfileQuery";
import { Badge, Avatar, Menu, Dropdown, Icon, Spin } from "antd";
import { NavLink } from "react-router-dom";

import LogoutButton from "../AuthProvider/LogoutButton";

export interface AvatarUser {
  id: string;
  email: string;
  ldapDN?: string | null;
  avatarSrc?: string;
  name: string;
  roles: Array<{
    name: string;
  }>;
}

export interface Props {
  user: AvatarUser | null;
}

const menu = (
  <Menu>
    <Menu.Item key="2">
      <NavLink to="/me">
        <Icon type="setting" />
        Account settings
      </NavLink>
    </Menu.Item>
    <Menu.Divider />
    <Menu.Item key="3">
      <LogoutButton />
    </Menu.Item>
  </Menu>
);

const UserAvatar = ({ user }: Props) =>
  user ? (
    <Dropdown className="avatar-menu" placement="bottomRight" overlay={menu}>
      <div
        style={{
          height: 62,
          marginRight: 16
        }}
      >
        <Badge count={2}>
          <Avatar
            size="large"
            // tslint:disable-next-line:max-line-length
            icon="user"
            src={user.avatarSrc}
          />
        </Badge>
        <span style={{ paddingLeft: 10 }}>{user.name}</span>
      </div>
    </Dropdown>
  ) : null;

export default () => {
  return (
    <ProfileQuery>
      {({ loading, error, data }) => {
        if (!data) {
          return null;
        }
        if (loading) {
          return <Spin />;
        }
        if (error) {
          return <h1>ERROR</h1>;
        }
        return <UserAvatar user={data.me} />;
      }}
    </ProfileQuery>
  );
};



// WEBPACK FOOTER //
// ./src/components/NavTop/UserAvatar.tsx